import { render } from "./CourseWidget.vue?vue&type=template&id=a45bda6a&ts=true"
import script from "./CourseWidget.vue?vue&type=script&lang=ts"
export * from "./CourseWidget.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__